import React from 'react';
import PropTypes from 'prop-types';

const ExitFullscreenPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M20.5 5a.5.5 0 0 0-.5.5v8a1.5 1.5 0 0 0 1.5 1.5h8a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5H25a1 1 0 0 1-1-1V5.5a.5.5 0 0 0-.5-.5h-3zm-12 0a.5.5 0 0 0-.5.5V10a1 1 0 0 1-1 1H2.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h8a1.5 1.5 0 0 0 1.5-1.5v-8a.5.5 0 0 0-.5-.5h-3zm13 14a1.5 1.5 0 0 0-1.5 1.5v8a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5V24a1 1 0 0 1 1-1h4.5a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-8zm-19 0a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5H7a1 1 0 0 1 1 1v4.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-8a1.5 1.5 0 0 0-1.5-1.5h-8z"
    />
  );
};

ExitFullscreenPath.propTypes = {
  fill: PropTypes.string,
};

export default ExitFullscreenPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/media-playback/exit-fullscreen.jsx